import axios from 'axios';

import type {
  PdfCurrentResponse,
  PdfJobStatusResponse,
  PdfStartJobRequest,
  PdfStartJobResponse,
  PdfUploadIntent,
} from '../types/pdfImport';
import type { ResponseType } from '../types/responses';

import { apiClient } from './apiClient';

export const pdfImportProvider = {
  createUploadIntent: (): Promise<ResponseType<PdfUploadIntent>> =>
    apiClient<PdfUploadIntent>('/ai-listing/pdf-uploads', 'POST', {}),

  uploadToStorage: async (
    intent: PdfUploadIntent,
    file: File,
    signal: AbortSignal,
    onProgress: (loaded: number, total?: number) => void
  ): Promise<void> => {
    const form = new FormData();
    Object.entries(intent.fields).forEach(([name, value]) => form.append(name, value));
    form.append('file', file);

    // The presigned POST is outside apiClient: it must not receive a Keycloak token.
    const response = await axios.post(intent.url, form, {
      signal,
      onUploadProgress: (event) => onProgress(event.loaded, event.total),
    });
    if (response.status !== 204) throw new Error('storage_upload_rejected');
  },

  startJob: (request: PdfStartJobRequest): Promise<ResponseType<PdfStartJobResponse>> =>
    apiClient<PdfStartJobResponse>('/ai-listing/pdf-jobs', 'POST', request),

  getCurrent: (): Promise<ResponseType<PdfCurrentResponse>> =>
    apiClient<PdfCurrentResponse>('/ai-listing/pdf-jobs/current', 'GET'),

  cancelJob: (jobId: string): Promise<ResponseType<PdfJobStatusResponse>> =>
    apiClient<PdfJobStatusResponse>(
      `/ai-listing/pdf-jobs/${encodeURIComponent(jobId)}/cancel`,
      'POST',
      {}
    ),
};
